import { useState } from 'react';

// ============================================================
// useSocialExchange
// Owns: handle/platform state + all social exchange handlers.
// Depends on: call (API wrapper from useChatActions)
// Returns: handle, setHandle, platform, setPlatform,
//          handleShareAndAsk, handleAskOnly, handleShareOnly, handleDecline
// ============================================================
export default function useSocialExchange({ call }) {
  const [handle, setHandle]     = useState('');
  const [platform, setPlatform] = useState('instagram');

  const handleShareAndAsk = async () => {
    const r = await call('post', '/social/share-and-ask', { handle: handle.trim(), platform });
    if (r) setHandle('');
  };

  const handleAskOnly = async () => call('post', '/social/ask', {});

  const handleShareOnly = async () => {
    const r = await call('post', '/social/share', { handle: handle.trim(), platform });
    if (r) setHandle('');
  };

  const handleDecline = async (reason) => call('post', '/social/decline', { reason });

  return { handle, setHandle, platform, setPlatform,
           handleShareAndAsk, handleAskOnly, handleShareOnly, handleDecline };
}
